import React, { useState, useEffect } from 'react';
import ReCaptcha from "react-google-recaptcha";
import {FormTypes, ErrorCodes, AppViews} from "resources/enums"
import { confirmAlert } from 'react-confirm-alert';
import { Constants, LoginRequest, UpdateUserSubscriptionsRequest, RecoveryAccountSendEmailRequest, GetSitePublicationsRequest, CheckJwtValidityRequest, SendActivationMailRequest} from "resources/constants"
import * as Utils from 'utils/utils';
import { resourceManager } from 'helpers/resourceManager';


export default function CredentialsModal({closeModal}){

    // Variables de estado
    const [sitePublications, setSitePublications] = useState([]);
    const [userSiteSubscriptions, setUserSiteSubscriptions] = useState([]);
    const [initialRun, setInitialRun] = useState(0);
    const captchaRef = React.createRef();
    const [isLogged, setIsLogged] = useState(checkUserStatus);
    const [btnSubs, setbtnSubs] = useState(false);
    const [formObject, setFormObject] = useState({
        email: "",
        password: "",
        subscriptions: [],
        captcha: false
    });    
    const [showLoaderAux, setShowLoader] = useState(true);
    const [loggedUser, setLoggedUser] = useState();
    const [captchaKey, setCaptchakey] = useState();

    //Métodos para visualizar la contraseña    
    const [shownPassword, setShownPassword] = useState(false);
    const switchShownPassword = () => setShownPassword(!shownPassword);

    var variant = Utils.getCurrentVariant();

    // Eventos de efecto
    useEffect(() => {    
        checkJwtValidity();          
    }, [initialRun])

    useEffect(() => {  
        setIsLogged(checkUserStatus);
    })

    // Métodos utilizados en las distintas acciones de usuario y carga de la app
    const checkUserStatus = () => {
        //Call login service here
        var status = false;
        if (sessionStorage.getItem(Constants.SessionStorage.UserToken) != null && sessionStorage.getItem(Constants.SessionStorage.UserToken) != ""){
            status = true;
        }
        return status;
    }  
    
    const checkJwtValidity = () =>{
        
        var jwt = sessionStorage.getItem(Constants.SessionStorage.UserToken);
        if(jwt != null && jwt != ""){
            var request = CheckJwtValidityRequest;
            request.jwtoken = jwt;
            Utils.JWTService(request, Constants.Subscriptions.CheckJwtValidity).then((response) => {
                setShowLoader(false);
                if(response.status != null){
                    if(response.status == 405){
                        sessionStorage.removeItem(Constants.SessionStorage.UserToken)
                        getCurrentSitePublications();
                    }
                }
                else if(response.errorCode != null){
                    if(response.errorCode != 0){
                        confirmAlert({
                            title: response.error,
                            buttons: [
                                {
                                    label: "Ok"
                                }
                            ]
                        }) 
                    }  
                    else{
                        if(response.userToken != null && response.userToken != ""){
                            sessionStorage.setItem(Constants.SessionStorage.UserToken, response.userToken);
                            if(response.user != null){
                                setLoggedUser(response.user);
                            }
                        }
                        else{
                            sessionStorage.removeItem(Constants.SessionStorage.UserToken)
                        }
                        getCurrentSitePublications();
                    }
                }         
            }) 
        }
        else{
            getCurrentSitePublications();
        }
    }

    const getCurrentSitePublications = () => {
        
        // 1.	Obtener url del site del usuario y coger LocalPath
        var path = unescape(window.location.pathname).toLowerCase();
        // 2.	Sustituir la variante por {idioma} en caso de existir
        var request = GetSitePublicationsRequest;
        request.body.siteUrl = path.replace(variant, Constants.Keys.GenericVariant);;
        request.body.languageKey =  variant;
        request.jwtoken = sessionStorage.getItem(Constants.SessionStorage.UserToken);

        // 3.   Llamamos al servicio donde buscará las publicaciones del sitio para suscribirse
        Utils.JWTService(request, Constants.Subscriptions.GetSitePublications).then((response) => {
            setShowLoader(false);
            if(response.status != null){
                if(response.status == 405){
                    sessionStorage.removeItem(Constants.SessionStorage.UserToken)
                }
            }
            else if(response.errorCode != 0){
                confirmAlert({
                    title: response.error,
                    buttons: [
                        {
                            label: Constants.Literals.Ok,
                            onClick: () => {
                                if(response.errorCode == 503 || response.errorCode == 1000){
                                    closeModal();
                                }
                            }
                        }
                    ]
                })   
            }
            else{
                if(response.publications != null){
                    setSitePublications(response.publications);
                }
                if(response.userSiteSubscriptions != null){
                    setUserSiteSubscriptions(response.userSiteSubscriptions);
                }
                else{
                    setIsLogged(false)
                }
             
            }            
        })
    }

    // Métodos para gestión de captcha
    const verifyCaptcha = (token) => {
        if(token){
            formObject.captcha = true;   
            setCaptchakey(token);  
        }
    }

    const expireCaptcha = () => {
        formObject.captcha = false;
        setCaptchakey("");
    }

    // Métodos para gestión de botones y formulario
    const onClickRegister = () => {
        sessionStorage.setItem(Constants.AppViews.Key, Constants.AppViews.NewUser);
        window.location.href = location.origin + Constants.PageUrls.Subscriptions.replace(Constants.Keys.GenericVariant, variant);
    }

    const onClickManage = () => {
        window.location.href = location.origin + Constants.PageUrls.Subscriptions.replace(Constants.Keys.GenericVariant, variant);
    }

    const onClickSubscribe = () => {
        if(formObject.subscriptions .length > 0 ){
            var request2 = UpdateUserSubscriptionsRequest;
            request2.body.subscriptions = formObject.subscriptions;
            request2.jwtoken = sessionStorage.getItem(Constants.SessionStorage.UserToken);
            Utils.JWTService(request2, Constants.Subscriptions.UpdateUserSubscriptions).then((response) => {
                if(response.status != null){
                    if(response.status == 405){
                        sessionStorage.removeItem(Constants.SessionStorage.UserToken)
                    }
                }
                else if(response.errorCode != 0){
                    sessionStorage.removeItem(Constants.SessionStorage.UserToken)
                    confirmAlert({
                        title: response.error,
                        buttons: [
                            {
                                label: Constants.Literals.Ok
                            }
                        ]
                    });
                }
                else{
                    window.location.href = location.origin + Constants.PageUrls.Subscriptions.replace(Constants.Keys.GenericVariant, variant);
                    sessionStorage.setItem(Constants.SessionStorage.UserToken, response.userToken);
                }
            })
        }
    }

    const onClickLogin = () => {     
          
        var resultValidation = Utils.validateFields(FormTypes.LOGIN, formObject);
        if(!resultValidation.hasError){
            setShowLoader(true); 
            var request = LoginRequest;
            request.userEmail = formObject.email;
            request.password =  formObject.password;
            request.languageKey = variant;
            request.groupId = Constants.Keys.GroupId;
            request.captchaKey = captchaKey;
            Utils.SimpleService(request, Constants.Subscriptions.Login).then((response) => {
                if(response.errorCode != 0){
                    
                    setShowLoader(false); 
                    sessionStorage.removeItem(Constants.SessionStorage.UserToken)
                    switch(response.errorCode){
                        case 13:
                            confirmAlert({
                                title: response.error,
                                buttons: [
                                    {
                                        label: resourceManager.getResource('SendActivationMailButton'),
                                        onClick: () => {
                                            setShowLoader(true); 
                                            var request = SendActivationMailRequest;
                                            request.email = formObject.email;
                                            Utils.SimpleService(request, Constants.Subscriptions.SendNewActivationEmail).then((response) => {
                                                setShowLoader(false); 
                                                if(response.errorCode != 0){
                                                    formObject.email = "";
                                                    formObject.password = "";
                                                    confirmAlert({
                                                        title: response.error,
                                                        buttons: [
                                                            {
                                                                label: resourceManager.getResource('Cancel')
                                                            }
                                                        ]
                                                    });
                                                }
                                                else{
                                                    if(response.sendedEmail){
                                                        confirmAlert({
                                                            title: resourceManager.getResource('SendActivationMailOK'),
                                                            buttons: [
                                                                {
                                                                    label: resourceManager.getResource('Ok')
                                                                }
                                                            ]
                                                        })
                                                    }
                                                    else{
                                                        confirmAlert({
                                                            title: resourceManager.getResource('SendActivationMailError'),
                                                            buttons: [
                                                                {
                                                                    label: resourceManager.getResource('Ok')
                                                                }
                                                            ]
                                                        })
                                                    }
                                                }
                                            })
                                        }
                                    },
                                    {
                                        label: resourceManager.getResource('Cancel'),
                                        onClick: () => {
                                            formObject.email = "";
                                            formObject.password = "";
                                        }
                                    }
                                ]
                            });
                            break;
                        case 21:
                            confirmAlert({
                                title: resourceManager.getResource('ServiceMessage21'),
                                buttons: [
                                    {
                                        label: resourceManager.getResource('Ok')
                                    }
                                ]
                            });
                            break;
                        default:
                            confirmAlert({
                                title: response.error,
                                buttons: [
                                    {
                                        label: resourceManager.getResource('Cancel')
                                    }
                                ]
                            });
                            break;
                    }
                }
                else{
                    sessionStorage.setItem(Constants.SessionStorage.UserToken, response.userToken);
                    setIsLogged(checkUserStatus());
                    sessionStorage.setItem(Constants.AppViews.Key, Constants.AppViews.UserAdministration);

                    if(formObject.subscriptions.length > 0 ){
                        var request2 = UpdateUserSubscriptionsRequest;
                        request2.body.subscriptions = formObject.subscriptions;
                        request2.jwtoken =  sessionStorage.getItem(Constants.SessionStorage.UserToken);
                        Utils.JWTService(request2, Constants.Subscriptions.UpdateUserSubscriptions).then((response) => {
                            if(response.status != null){
                                if(response.status == 405){
                                    sessionStorage.removeItem(Constants.SessionStorage.UserToken)
                                }
                            }
                            else if(response.errorCode != 0){
                                setShowLoader(false); 
                                sessionStorage.removeItem(Constants.SessionStorage.UserToken)
                                confirmAlert({
                                    title: response.error,
                                    buttons: [
                                        {
                                            label: Constants.Literals.Ok
                                        }
                                    ]
                                });
                            }
                            
                        })
                        
                    }
                
                    window.location.href = location.origin + Constants.PageUrls.Subscriptions.replace(Constants.Keys.GenericVariant, variant);
                    
                }
            });
        }
        else{
            confirmAlert({
                title: resourceManager.getResource(ErrorCodes[resultValidation.errorCode]),
                buttons: [
                    {
                        label: Constants.Literals.Ok
                    }
                ]
            });
        }
    }

    const onClickRecoveryText = () => {
        var resultValidation = Utils.validateFields(FormTypes.RECOVERY, formObject);
            if(!resultValidation.hasError){
                var request = RecoveryAccountSendEmailRequest;
                request.email = formObject.email;
                request.captchaKey = captchaKey;
                confirmAlert({
                    title: resourceManager.getResource('RecoveryAccountModal'),
                    buttons: [
                        {
                            label: Constants.Literals.Ok,
                            onClick: () => {
                                setShowLoader(true);
                                Utils.SimpleService(request, Constants.Subscriptions.RecoveryAccountSendMail).then((response) => {
                                    setShowLoader(false); 
                                    var modalMsg = resourceManager.getResource('RecoveryAccountModalMailSended');
                                    if(response.errorCode == 21){
                                        modalMsg = resourceManager.getResource('ServiceMessage21');
                                    }
                                    confirmAlert({
                                        title: modalMsg,
                                        buttons: [
                                            {
                                                label: Constants.Literals.Ok
                                            }
                                        ]
                                    }); 
                                })
                                
                            }
                        },
                        {
                            label: Constants.Literals.Cancel,
                        }
                    ]
                });
            }
            else{
                confirmAlert({
                    title: resourceManager.getResource(ErrorCodes[resultValidation.errorCode]),
                    buttons: [
                        {
                            label: Constants.Literals.Ok,
                            
                        }
                    ]
                });
            }
    }

    const onChangeContent = (e) => {
        switch(e.target.type){
            case Constants.FieldTypes.Text:
            case Constants.FieldTypes.Password:
                formObject[e.target.name] = e.target.value;
                break;
            case Constants.FieldTypes.CheckBox:
                getSubscriptionsCheckBoxes(e.target)
                break;
        }
    }

    const getSubscriptionsCheckBoxes = (checkbox) => {
        var channel = 0;
        if(checkbox.value == Constants.Keys.Email){
            channel = 2;
        }
        else if(checkbox.value == Constants.Keys.Sms){
            channel = 1;
        }
        if(checkbox.checked){
            formObject.subscriptions.push({publicationId: checkbox.id, channelId: channel, status: true}); 
        }
        else{
            formObject.subscriptions.pop({publicationId: checkbox.id, channelId: channel, status: false}); 
        }
        if(formObject.subscriptions.length > 0){
            setbtnSubs(true);
        }
        else{
            setbtnSubs(false);
        }
    }

    //Renderizado
    return (  
        <>
       <section role="contentinfo" aria-label={resourceManager.getResource('SubscribeAriaLabel')}>
        
            <div id="SuscrModal" className="SuscrModal">
            {showLoaderAux && (<div id="preloader">
                    <div id="loader"></div>
                </div>)
            } 
            {!showLoaderAux && (             
                /* <!-- SuscrModal contenido -->*/
                <div className="SuscrModal-contenido">
                    <div className="SuscrModal-header">
                        <h1>{resourceManager.getResource('SubscribeTitle')}</h1>
                        <input type="button" className="cerrarSuscrModal" value="x" title="Cerrar ventana Suscríbete" onClick={closeModal} />
                        {isLogged &&
                            <div class="texto_introduccion">
                                {loggedUser && loggedUser.name &&
                                    <p>{resourceManager.getResource('BellGreetingLogged')}<span>{loggedUser.name}</span>!</p>
                                }
                                {!loggedUser || !loggedUser.name &&
                                    <p>{resourceManager.getResource('BellGreeting')}</p>
                                }
                                {sitePublications.length > 0 &&
                                    <p>{resourceManager.getResource('BellText01')}</p>
                                }
                            </div>
                        }

                    </div>
                    <div className="SuscrModal-body">
                        {sitePublications.length>0 && (
                            <div>
                                <span>{Constants.Keys.EmailText}</span>
                                <span>{Constants.Keys.SmsText}</span>
                                {/* <!-- SuscrModal Checkboxes  --> */
                                    sitePublications.map((pub, index) => {
                                        var checkedSms = false;
                                        var checkedEmail = false;
                                        var userHasPhone = true;
                                        if (isLogged) {
                                            userHasPhone =loggedUser.mobilePhone && loggedUser.mobilePhone!="";
                                        } 
                                        userSiteSubscriptions.forEach(sub => {
                                            if(sub.publicationId == pub.id){
                                                if(sub.channelId == Constants.Keys.SmsChannelId){
                                                    checkedSms = true;
                                                }
                                                else if(sub.channelId == Constants.Keys.EmailChannelId){
                                                    checkedEmail = true;
                                                }
                                            } 
                                        })
                                        return(
                                            <div>
                                                <div key={index} className='SuscrModal-checks'>
                                                    <label id="chkbxNoticias">{pub.name}</label>
                                                    {checkedEmail &&
                                                        <input type="checkbox" id={pub.id} value="email" title={resourceManager.getResource('ToolTipCheckBell')} checked disabled aria-labelledby="chkbxNoticias" onChange={onChangeContent}/>
                                                    }
                                                    {!checkedEmail &&
                                                        <input type="checkbox" id={pub.id} value="email" aria-labelledby="chkbxNoticias" onChange={onChangeContent}/>
                                                    }
                                                    {checkedSms && userHasPhone &&
                                                        <input type="checkbox" id={pub.id} value="sms" title={resourceManager.getResource('ToolTipCheckBell')} checked disabled aria-labelledby="chkbxNoticias" onChange={onChangeContent}/>
                                                    }
                                                    {!checkedSms && userHasPhone &&
                                                        <input type="checkbox" id={pub.id} value="sms" aria-labelledby="chkbxNoticias" onChange={onChangeContent}/>
                                                    }
                                                    {isLogged && !userHasPhone &&
                                                        <input type="checkbox" id={pub.id} value="sms" disabled aria-labelledby="chkbxNoticias" onChange={onChangeContent}/>
                                                    }                                                
                                                </div>
                                                <p className="suscrChckbxCustom-info">{pub.description}</p>
                                            </div>
                                        )
                                    })                            
                                }   
                            </div>                            
                        )}                            
                        {!isLogged &&
                            // <!-- SuscrModal Iniciar sesion --> 
                            <div id="SuscrModal-IniciarSesion" className="SuscrModal-IniciarSesion">
                                <label htmlFor="suscrInicaSesionEmail" ><span className="oculto">{resourceManager.getResource('EnterEmail')}</span>
                                    <input id="suscrInicaSesionEmail" type="text"  placeholder="email" name="email" onChange={onChangeContent}/>
                                </label>
                                <label htmlFor="suscrInicaSesionContrasena" ><span className="oculto">{resourceManager.getResource('EnterPass')}</span>
                                <div className="elementospassword">
                                    <input id="suscrInicaSesionContrasena" type={shownPassword? 'text' : 'password'} placeholder="contraseña" name="password" onChange={onChangeContent}/>
                                    <input type='button' onClick={switchShownPassword} value={shownPassword? 'Ocultar':'Mostrar'} class="passwordButton" />
                                </div>                                    
                                </label>
                                <div id="captchaGoogle">
                                    <ReCaptcha  
                                        ref={captchaRef}
                                        sitekey={window.minhac.settings.ReCaptchaPubKey}
                                        onChange={verifyCaptcha}
                                        onExpired={expireCaptcha}
                                    />
                                </div>
                    
                                <label htmlFor="suscrIniciaSesionBoton" ><span className="oculto">{resourceManager.getResource('LoginButton')}</span>
                                    <input id="suscrIniciaSesionBoton" type="button" value={resourceManager.getResource('LoginAuthentication')} onClick={onClickLogin}/>
                                </label>
                                
                                <p><a id="suscrRecuperarContrasenaLink" onClick={onClickRecoveryText} href="#" >{resourceManager.getResource('LoginRecoverPass')}</a></p>                            
                            </div>                         
                        }        
                    </div>
  
                    {!isLogged &&
                        <div className="SuscrModal-footer" align="center">
                            <p>{resourceManager.getResource('LoginSignUpText')}</p> 
                            <p><input type="button" id="SuscrModal-Registrate" onClick={onClickRegister} value={resourceManager.getResource('LoginSignUpUperCase')} /></p>
                        </div>
                    }
                    {isLogged && sitePublications.length > 0  && !btnSubs &&
                        <div className="SuscrModal-footer" align="center">
                            <p><input type="button" id="SuscrModal-Registrate" disabled onClick={onClickSubscribe} value={resourceManager.getResource('SubscribeTitleUperCase')} /></p>
                            <div class="texto_recordatorio">
                                <p>{resourceManager.getResource('BellText02')}</p>
                                <a href="#">{loggedUser.email}</a>
                                <p>{resourceManager.getResource('BellText03')}</p>
                            </div>
                        </div>
                    }
                    {isLogged && sitePublications.length > 0  && btnSubs &&
                        <div className="SuscrModal-footer" align="center">
                            <p><input type="button" id="SuscrModal-Registrate" onClick={onClickSubscribe} value={resourceManager.getResource('SubscribeTitleUperCase')} /></p>
                            <div class="texto_recordatorio">
                                <p>{resourceManager.getResource('BellText02')}</p>
                                <a href="#">{loggedUser.email}</a>
                                <p>{resourceManager.getResource('BellText03')}</p>
                            </div>
                        </div>
                    }
                    {isLogged &&
                        <div className="SuscrModal-footer" align="center">
                            <p><input type="button" id="SuscrModal-Gestion" onClick={onClickManage} value={resourceManager.getResource('SubscriptionsManagerUperCase')} /></p>
                        </div>
                    }
                </div>)
            }
            </div>
        </section>
        </>  
    )
}